package org.solyton.solawi.bid.application.ui.page.user.`data`

import kotlin.Int
import kotlin.Long
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.application.ui.page.user.`data`.filter.UserFilterQuery
import org.solyton.solawi.bid.application.ui.page.user.`data`.sort.UserSortOrder

/**
 * Autogenerated Lens.
 * Read and manipulate [UiState.filter]
 */
@ReadWrite
public val filter: Lens<UiState, UserFilterQuery> by lazy {
      Lens(
        get = { whole -> whole.filter },
        set = { part -> { whole -> whole.copy(filter = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiState.filter]
 */
@ReadWrite
public fun UiState.filter(`set`: UserFilterQuery.() -> UserFilterQuery): UiState = copy(filter =
    set(filter))

/**
 * Autogenerated Lens.
 * Read and manipulate [UiState.sortOrder]
 */
@ReadWrite
public val sortOrder: Lens<UiState, UserSortOrder> by lazy {
      Lens(
        get = { whole -> whole.sortOrder },
        set = { part -> { whole -> whole.copy(sortOrder = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiState.sortOrder]
 */
@ReadWrite
public fun UiState.sortOrder(`set`: UserSortOrder.() -> UserSortOrder): UiState = copy(sortOrder =
    set(sortOrder))

/**
 * Autogenerated Lens.
 * Read and manipulate [UiState.pageSize]
 */
@ReadWrite
public val pageSize: Lens<UiState, Int> by lazy {
      Lens(
        get = { whole -> whole.pageSize },
        set = { part -> { whole -> whole.copy(pageSize = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiState.pageSize]
 */
@ReadWrite
public fun UiState.pageSize(`set`: Int.() -> Int): UiState = copy(pageSize = set(pageSize))

/**
 * Autogenerated Lens.
 * Read and manipulate [UiState.pageOffset]
 */
@ReadWrite
public val pageOffset: Lens<UiState, Long> by lazy {
      Lens(
        get = { whole -> whole.pageOffset },
        set = { part -> { whole -> whole.copy(pageOffset = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [UiState.pageOffset]
 */
@ReadWrite
public fun UiState.pageOffset(`set`: Long.() -> Long): UiState = copy(pageOffset = set(pageOffset))
